import AuthController from "./controllers/auth-controller";

export const showAuthPopup = () => {
  new AuthController().show();
};

window.showAuthPopup = showAuthPopup;
